export default new class Helpers {
  constructor() {
    this.lazyDropdownDelay = 250;
    this.bodyFixedClass = '_fixed';
    this.fieldCheckedAttrName = 'data-is-checked';
  }

  /**
     * Lazy dropdown (when user hovers item, dropdown shows with a delay)
     *
     * @param hoverItemsClassName -  string,class name of item (elem of menu)
     * @param dropDownClassName - string, class name of dropdowns
     */
  lazyDropdown(hoverItemsClassName, dropDownClassName) {
    let timer;

    $(hoverItemsClassName).hover((e) => {
      $(e.target).find(dropDownClassName);

      timer = setTimeout(() => {
        $(e.target).find(dropDownClassName).show();
      }, this.lazyDropdownDelay);
    }, (e) => {
      clearTimeout(timer);
      $(e.target).closest(hoverItemsClassName).find(dropDownClassName).hide(0);
    });
  }

  /**
     * Set body fixed, save and set scroll prev position of body
     *
     * addFixed - boolean, if true - adds fixed to body
     * removeFixed  - boolean, if true - removes fixed from body
     */
  toggleScrollBodyMobile(addFixed = null, removeFixed = null) {
    const $body = $('body');

    if (!$body.hasClass(this.bodyFixedClass) || addFixed) {
      this.scrollPosition = $body.scrollTop();
      $body.addClass(this.bodyFixedClass);
    } else {
      $body.removeClass(this.bodyFixedClass);
    }

    if (removeFixed) {
      $body.removeClass(this.bodyFixedClass);
    }

    $body.css('top', -this.scrollPosition);
    $body.scrollTop(this.scrollPosition);
  }

  /**
     * Check is mobile version of the site  opened
     *
     * @returns {boolean} - is mobile version
     */
  isMobile() {
    if ($('body').hasClass('mobile')) {
      return true;
    }
    return false;
  }

  /**
     * Toggle class to element
     * @param {Object} $element
     * @param {string} className
     * @param {boolean} isShow
     */
  toggleClassToElement($element, className, isShow) {
    if (isShow) {
      $element.addClass(className);
      return;
    }

    $element.removeClass(className);
  }

  /**
     * Scroll page to top
     * @param {Object} e
     * @param $scrollElem - jquery obj, this elem should be scrolled to top
     */
  scrollPageToTop(e, $scrollElem = $('html, body')) {
    e.preventDefault();

    $scrollElem.stop().animate({
      scrollTop: 0,
    }, 'swing');
  }

  markFieldAsChecked($input) {
    $input.attr(this.fieldCheckedAttrName, true);
  }

  markFieldAsUnchecked($input) {
    $input.attr(this.fieldCheckedAttrName, false);
  }

  isFieldChecked($input) {
    return $input.attr(this.fieldCheckedAttrName) === 'true';
  }

  setHeaderMenuActiveItemIntoView() {
    const $headerSection = $('.header__section');
    if (!$headerSection.length) {
      return;
    }
    const $body = $('body');
    const subDomain = $body.attr('data-sub-domain');
    const headerMenuItemMargin = parseInt($('.header__section-item').css('margin-right'), 10);
    const headerContentOffsetLeft = $('.header__content').offset().left;
    const $activeHeaderMenuItem = $headerSection.find(`.header__section-item._active[data-sub-domain='${subDomain}']`);

    if (!$activeHeaderMenuItem.length) {
      return;
    }

    $headerSection
      .scrollLeft(
        $activeHeaderMenuItem.offset().left - headerContentOffsetLeft - headerMenuItemMargin,
      );
  }

  setPersonalAreaMenuItemIntoView() {
    const $persAreaMenu = $('.personal-area__tabs');
    const $body = $('body');
    const pageId = $body.attr('data-page-id');
    const containerLeftPadding = parseInt($('.container').css('padding-left'), 10);
    const $persAreaActiveMenuItem = $persAreaMenu.find(`.personal-area__tabs-item.active[data-page-id="${pageId}"]`);

    if (!$persAreaActiveMenuItem.length) {
      return;
    }

    $persAreaMenu.scrollLeft($persAreaActiveMenuItem.offset().left - containerLeftPadding);
  }

  getModalType($modal) {
    return $modal.find('[data-modal]').attr('data-modal');
  }
}();
